import { useContext, /**useRef*/ } from "react";
import { ErrorDialogContext, /**errorHandledAsync,*/ errorHandledSync, } from "@/shared/context/error-context";
import { UpdateUserIdService } from "@/features/user/services/update-id-service";
import { useUpdateIdStates } from "@/features/user/hooks/use-update-id-states";
// import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { utilities } from "@/shared/utils/utility";
import { useValidators } from "@/shared/utils/validate";
import { useLoginContext } from "@/features/auth/contexts/login-context";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";

interface Props {
  onTapCompleteModal: () => void;
}

export const useUpdateUserId = ({ onTapCompleteModal }: Props) => {
  const updateUserIdService = new UpdateUserIdService();

  const {
    email,
    setEmail,
  } = useLoginContext();

  const {
    newEmail,
    setNewEmail,
    emailError,
    setEmailError,
    //emailConfirm,
    //setEmailConfirm,
    //emailConfirmError,
    //setEmailConfirmError,
    isActiveUpdateButton, // 更新ボタンの有効フラグ
    setIsActiveUpdateButton,
    isShowErrorDialog, // エラーダイアログ表示フラグ情報
    setIsShowErrorDialog,
  } = useUpdateIdStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // 共通関数の呼び出し
  const { validatesForm } = utilities();
  const { mailAddressValidator } = useValidators();

  const loadingCtx = useContext(LoadingModalContext);

  // ボタン押下イベント ======================================
  // 「更新」押下時のコールバック
  const onClickUpdate = async (
    email: string,
    //emailConfirm: string,
  ) => {
    loadingCtx.setIsLoading(true);

    try {
      const emailValidationError = validatesForm([mailAddressValidator], email, setEmailError);
      if (!emailValidationError) {
        return;
      }

      //const emailConfirmValidationError = validatesForm([mailAddressValidator], emailConfirm, setEmailConfirmError);
      //if (!emailConfirmValidationError) {
      //  return;
      //}
      //if (email !== emailConfirm) {
      //  setEmailConfirmError("メールアドレスが一致していません");
      //  return;
      //}
      await updateUserIdService.updateUserId({
        owner_id: email
      });
      sessionStorage.setItem("email", email);
      onTapCompleteModal();
    } catch (error) {
      console.log(error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  // メールアドレス変更イベント
  const onChangeMailAddress = (value: string) => {
    setNewEmail(value);
  };

  // メールアドレス（確認）変更イベント
  //const onChangeMailAddressConfirm = (value: string) => {
  //  setEmailConfirm(value);
  //};

  // エラーダイアログを閉じる
  const closeErrorDialog = () => {
    setIsShowErrorDialog({
      isError: false,
      errorMessage: "",
    });
  };

  // ユーザーID情報が更新された場合のコールバック関数
  const changeUpdateButtonState = () => {
    setIsActiveUpdateButton(newEmail !== "");
  };

  return {
    email,
    newEmail,
    setNewEmail,
    emailError,
    //emailConfirmError,
    isActiveUpdateButton,
    isShowErrorDialog,
    onChangeMailAddress: errorHandledSync(onChangeMailAddress, setError),
    //onChangeMailAddressConfirm: errorHandledSync(onChangeMailAddressConfirm, setError),
    onClickUpdate: errorHandledSync(onClickUpdate, setError),
    //resetMailAddress: errorHandledSync(resetMailAddress, setError),
    closeErrorDialog: errorHandledSync(closeErrorDialog, setError),
    changeUpdateButtonState: errorHandledSync(changeUpdateButtonState, setError),
  };
};
